import { Message } from 'element-ui';
import dayjs from 'dayjs';

const DEFALUT_QUALITY = 0.8; // 默认的图片压缩质量
const ONE_KB = 1024; // 1KB大小
const ONE_MB = 5;
const DEFALUT_LIMITSIZE = ONE_MB * ONE_KB; // 默认的压缩临界大小，500KB

/**
 * @description 复制内容到粘贴板
 * @param {*} txt 待复制内容值
 */
export const copyToClip = (txt) => {
    var input = document.createElement('input');
    input.setAttribute('value', txt);
    document.body.appendChild(input);
    // 选择对象
    input.select();
    // 执行浏览器复制命令
    document.execCommand('copy');
    document.body.removeChild(input);
    Message.success(`‘${input.value}’复制成功`);
};
/**
 * @dest 字符串转数组
 * @param {String} str 入参
 * @returns 数组|空值
 */
const strToArr = (str) => {
    return str ? str.split(',') : [];
};
/**
 * @dest 时间处理
 * @param {*} data 入参
 * @param {*} time 处理的对象
 * @param {*} returnTime1 返回时间字段
 * @param {*} returnTime2 返回时间字典
 */
const formatTime = (data, time, returnTime1, returnTime2) => {
    if (data[time] && data[time].length) {
        data[returnTime1] = data[time][0];
        data[returnTime2] = data[time][1];
    } else {
        data[returnTime1] = '';
        data[returnTime2] = '';
    }
};
/**
 * @dest 处理查询条件
 * @param {*} data 入参
 * @param {*} that this
 * @returns 格式后的参数
 */
export const formatSearchParams = (data, that) => {
    if (data.createTime && data.createTime.length) {
        data.beginDate = dayjs(data.createTime[0]).format('YYYY-MM-DD HH:mm:ss');
        data.endDate = dayjs(data.createTime[1]).format('YYYY-MM-DD HH:mm:ss');
    } else {
        data.beginDate = '';
        data.endDate = '';
    }
    formatTime(data, 'departureTime', 'beginDate1', 'endDate1');
    formatTime(data, 'requireArriveTime', 'requireArriveTimeBegin', 'requireArriveTimeEnd');
    formatTime(data, 'expectArriveTimes', 'expectArriveEndTimeStart', 'expectArriveEndTimeEnd');
    formatTime(data, 'appointmentTaskCreateTime', 'appointmentTaskCreateTimeFrom', 'appointmentTaskCreateTimeTo');
    formatTime(data, 'appointmentRecordCreateTime', 'appointmentRecordCreateTimeFrom', 'appointmentRecordCreateTimeTo');
    formatTime(data, 'appointmentTime', 'appointmentTimeFrom', 'appointmentTimeTo');
    formatTime(data, 'examineTime', 'examineTimeFrom', 'examineTimeTo');
    if (data.receiverProvinceCode) {
        data.receiverProvinceCodes = data.receiverProvinceCode.split(',');
    } else {
        delete data.receiverProvinceCodes
    }
    if (data.receiverCityCode) {
        data.receiverCityCodes = data.receiverCityCode.split(',');
    } else {
        delete data.receiverCityCodes
    }
    if (data.receiverDistrictCode) {
        data.receiverDistrictCodes = data.receiverDistrictCode.split(',');
    } else {
        delete data.receiverDistrictCodes
    }
    if (data.receiverTownCode) {
        data.receiverTownCodes = data.receiverTownCode.split(',');
    } else {
        delete data.receiverTownCodes
    }

    data.waveIdList = strToArr(data.waveId);
    delete data.receiverProvinceCode;
    delete data.receiverCityCode;
    delete data.receiverDistrictCode;
    delete data.receiverTownCode;
     // eslint-disable-next-line max-len
    ['waveId', 'createTime', 'departureTime', 'requireArriveTime', 'expectArriveTimes', 'appointmentTaskCreateTime', 'appointmentTime', 'appointmentRecordCreateTime', 'examineTime'].forEach(key => {
        delete data[key];
    });

    that.totalData = [];
    if (data.groupPolicy) that.groupPolicy = data.groupPolicy;
    return data;
};
/**
 * @dest 查询条件校验
 * @param {*} data 入参
 * @returns 布尔值
 */
export const checkSearchParams = (data) => {
    if (data.batchQueryKey) {
        data[data.batchQueryKey] = data.batchQueryValue ? data.batchQueryValue.split(',') : [];
    }
    if (!data[data.batchQueryKey].length && (!data.beginDate && !data.appointmentRecordCreateTimeFrom &&
        !data.appointmentTimeFrom && !data.appointmentTaskCreateTimeFrom && !data.examineTimeFrom)) {
        Message.warning('客户订单号 和 创建|分配任务|预约操作|预约|时效考核时间 不可同时为空');
        return false;
    }
    if (data.siteCode) {
        data.siteCodes = data.siteCode.split(',');
    }  else {
        data.siteCodes = []
    }
   if (!(data[data.batchQueryKey].length || data.chooseCode) && !data.siteName) {
        Message.warning('服务平台必填！');
        return false;
   }
    const timeList = [
        { startTime: 'beginDate', endTime: 'endDate' },
        { startTime: 'appointmentTaskCreateTimeFrom', endTime: 'appointmentTaskCreateTimeTo' },
        { startTime: 'appointmentRecordCreateTimeFrom', endTime: 'appointmentRecordCreateTimeTo' },
        { startTime: 'appointmentTimeFrom', endTime: 'appointmentTimeTo' },
        { startTime: 'examineTimeFrom', endTime: 'examineTimeTo' }
    ];
    for (let i = 0; i < timeList.length; i++) {
        const startTime = data[timeList[i].startTime] || 0;
        const endTime = data[timeList[i].endTime] || 0;
        const timeDifference = new Date(endTime).getTime() - new Date(startTime).getTime();
        if (!data[data.batchQueryKey].length && (data.taskStatusList.filter(v => v > 60).length || !data.taskStatusList.length)) {
            if (timeDifference > 3 * 24 * 60 * 60 * 1000) {
                Message.warning('订单状态包含待签收之后的状态或未选时，查询时间跨度不可超过3天！');
                return false;
            }
        }
        if (!data[data.batchQueryKey].length && data.siteCodes.length === 1 && data.taskStatusList.every(v => v < 70 )) {
            if (timeDifference > 93 * 24 * 60 * 60 * 1000) {
                Message.warning('单服务平台且所选状态≤待签收时，查询时间不可超过三个月');
                return false;
            }
        }
        if (!data[data.batchQueryKey].length && data.siteCodes.length > 1 && timeDifference > 32 * 24 * 60 * 60 * 1000) {
            Message.warning('多个服务平台，查询时间不可超过1个月！');
            return false;
        }
    }
    return true;
};
/**
 * @description 处理预约记录列表数据
 */
export const formatAppointmentRecordList = (list, dictData) => {
    if (!list.length) return [];
    list.forEach(item => {
        item.appointmentChangeFirstReasonValue && (item.reasonValue = item.appointmentChangeFirstReasonValue + '/' + item.appointmentChangeSecondReasonValue);
        item.requireInstallTypeName = dictData.INSTALL_TYPE[item.requireInstallType];
        item.appointmentTimes = item.appointmentTime ? dayjs(item.appointmentTime).format('YYYY-MM-DD') + ' ' + (item.appointmentTimeSlot || '')  : '';
        item.appointmentInstallTimes = item.appointmentInstallTime ? dayjs(item.appointmentInstallTime).format('YYYY-MM-DD') + ' ' + item.appointmentInstallTimeSlot : '';
        item.intervieweeMessage = item.intervieweeName ? `${item.intervieweeName || ''}/${item.intervieweeTel || ''}` : '';
        item.appointmentWayName = dictData.OTP_ACD_APPOINTMENT_TYPE[item.appointmentWay] || '';
    });
    return list;
};

/**
 * @description 处理拨号记录数据
 */
export const formatDialingRecordList = (list, dictData) => {
    if (!list.length) return [];
    list.forEach(item => {
        item.privacyProtectName = item.privacyProtect ? '是' : '否';
        item.callConnectedName = item.callConnected ? '是' : '否';
    });
    return list;
};

export const isB2C = (item) => {// 业务模式=B2C
    return item.businessMode === 'B2C';
};
export const isDOT = (item) => {// 配送方式=宅配
    return item.deliveryType === 'DOT';
};
export const isRiOrRri = (item) => {// 订单类型=退货入库单或拒收入库单
    return ['RI', 'RRI'].includes(item.orderType);
};
export const isComplete = (item) => {// 完成或之后
    return +item.taskStatus >= 100;
};
export const isAppointment = (item) => {// 已预约
    return +item.appointmentFlag === 1;
};
export const isRiOrDpri = (item) => { // 订单类型=退货入库单或上门取件退货单
    return ['RI', 'DPRI'].includes(item.orderType);
};
export const isDOTOrNet = (item) => { // 配送方式=网点配送、宅配
    return ['DOT', 'NET'].includes(item.deliveryType) && item.projectClassify !== 'JHLP';
};
export const isRiOrRriOrDpri = (item) => { // 订单类型=退货入库单或拒收入库单或上门取件退货单
    return ['RI', 'RRI', 'DPRI'].includes(item.orderType);
};
export const formatTableData = (initData, dictData) => {
    if (!initData.length) return [];
    initData.forEach(item => {
        item.hiddenEvent = [];
         // 预约：配送方式=宅配 || (业务模式=B2C & 订单类型=退货入库单或拒收入库单) || 100完成或之后 || 已预约 || (订单类型=上门取件退货单、退货入库单 && 配送方式=网点配送、宅配)
        if ((isB2C(item) && isRiOrRri(item)) || isComplete(item) || isAppointment(item) || item.orderTypeExt === 'CSP_REVERSE') {
            item.hiddenEvent.push('remove');
        }

        // 改约：配送方式=宅配 || (业务模式=B2C & 订单类型=退货入库单或拒收入库单) || 100完成或之后 || 未预约 || (订单类型=上门取件退货单、退货入库单 && 配送方式=网点配送、宅配)
        if ((isB2C(item) && isRiOrRri(item)) || isComplete(item) || !isAppointment(item) || item.orderTypeExt === 'CSP_REVERSE') {
            item.hiddenEvent.push('rescheduling');
        }

        // 分配：配送方式=宅配 || (业务模式=B2C & 订单类型=退货入库单或拒收入库单) || 100完成或之后 || (订单类型=上门取件退货单、退货入库单 && 配送方式=网点配送、宅配)
        if ((isB2C(item) && isRiOrRri(item)) || isComplete(item) || item.orderTypeExt === 'CSP_REVERSE') {
            item.hiddenEvent.push('allocation');
        }
        // 预约网点：逆向订单 &&任务状态=“待预约网点 | 待网点提货”
        if (!(item.orderTypeExt === 'CSP_REVERSE' && [-20, -10].includes(+item.taskStatus))) {
            item.hiddenEvent.push('appointmentBranch');
        }
        // 改约网点：逆向订单 && 任务状态=“待调度、待排车”
        if (!(item.orderTypeExt === 'CSP_REVERSE' && [0, 5].includes(+item.taskStatus))) {
            item.hiddenEvent.push('rescheduledBranch');
        }
        item.taskStatusName = dictData.TRANSPORT_STATUS[item.taskStatus];
        item.deliveryTypeName = dictData.DELIVERY_TYPE[item.deliveryType];
        item.orderTypeName = dictData.ORDER_TYPE[item.orderType];
        item.arriveAppointmentRequireFlagName = +item.arriveAppointmentRequireFlag === 3 ? '是' : '否';
        item.appointmentFlagName = +item.appointmentFlag === 1 ? '是' : '否';
        item.requireDialFlagName = +item.requireDialFlag === 1 ? '是' : '否';
        item.b2cZpFlagName = +item.b2cZpFlag === 1 ? '是' : +item.b2cZpFlag === 0 ? '否' : '';
        item.allocationDriverMessage = item.driver ? `${item.driver || ''}/${item.driverPhone || ''}` : item.driverPhone;
        item.senderDetailAddrs = `${item.senderProvinceName}/${item.senderCityName}/${item.senderDistrictName}/${item.senderTownName}/${item.senderDetailAddr}`;
        item.receiverDetailAddrs = `${item.finalProvinceName}/${item.finalCityName}/${item.finalDistrictName}/${item.finalTownName}/${item.finalDetailAddr}`;
        item.scPosFlagName = +item.scPosFlag === 1 ? '是' : '否';
        item.appointmentTimes = item.appointmentTimeNew ? (dayjs(item.appointmentTimeNew).format('YYYY-MM-DD') + ' ' + (item.appointmentTimeSlotNew || '')) : '';
        item.calledTodayName = item.calledToday ? '是' : '否';
        item.stateSubsidiesFlagName = item.stateSubsidiesFlag ? '是' : '否';
        item.appointmentTypeExtName = item.appointmentTypeExt === 'INTEGRATE' ? '是' : '否';
        item.vipFlag = (item.vipFlag !== undefined && item.vipFlag !== null) ? `${item.vipFlag}` : item.vipFlag;
    });
    return initData;
};

/** 来源系统=CAINIAO 且 订单类型=调拨出库、纯运输单。且非projectClassify=JHLP订单 */
export function isCaiNiaoAoOrYS(row) {
    return ['CAINIAO'].includes(row.sourceSystem) && ['AO', 'YS'].includes(row.orderType) && row.projectClassify !== 'JHLP';
}

/** 来源系统≠CAINIAO 且 客户属性=内部、美的渠道 且 配送方式≠宅配 且 专业公司分类=城配公司 且 判断 “transport_extend.targe_site_code”有值，则不支持预约。//剔除宅配是为了剔除安得个人购买场景 */
export function isPrivatePerson(row) {
    const isEmpty = val => [null, undefined, ''].includes(val);
    return row.sourceSystem !== 'CAINIAO' &&
            [1, 3].includes(+row.customerAttribute) &&
            row.deliveryType !== 'DOT' &&
            (+row.professionalCompany === 5) &&
            (!isEmpty(row.targeSiteCode));
}

/** 批量校验是否可分配/预约
 * @param { Array } list 批量分配列表
 * @returns Array 可进行分配的列表（过滤掉不可分配的数据）
 */
export function filterSupportAlloc(list) {
    const finishList = []; // 已签收
    const b2cList = []; // 2C退货
    const dotAndNetList = []; // 宅配、网点配送
    const cainiaoList = []; // 纯运输、菜鸟调拨出库
    const privatePersonList = []; // 收方为安得仓
    const cspReverseList = []; // 退货入库单
    const allowList = []; // 允许预约|分配列表

    [].concat(list).filter(Boolean).forEach(row => {
        if (isComplete(row)) {
            finishList.push(row);
        } else if (isB2C(row) && isRiOrRri(row)) {
            b2cList.push(row);
        } else if (isDOTOrNet(row)) {
            dotAndNetList.push(row);
        } else if (row.orderTypeExt === 'CSP_REVERSE') {
            // 退货入库单(订单类型=上门取件退货单、退货入库单 && 配送方式=网点配送、宅配)
            cspReverseList.push(row);
        } else if (isCaiNiaoAoOrYS(row)) {
            cainiaoList.push(row);
        } else if (isPrivatePerson(row)) {
            privatePersonList.push(row);
        } else {
            allowList.push(row);
        }
    });

    const taskNosStr = arr => arr.map(item => item.taskNo).join(',');
    const showMessage = message => {
        setTimeout(() => {
            Message.warning({ message, duration: 5000, showClose: true, customClass: 'max-zindex' });
        }, 0);
    };

    // 针对不同类型进行提示
    if (finishList.length) {
        showMessage(`订单号${taskNosStr(finishList)}，共${finishList.length}单已自动剔除, 已签收不能改约`);
    }

    if (b2cList.length) {
        showMessage(`订单号${taskNosStr(b2cList)}，共${b2cList.length}单已自动剔除, 2C退货订单禁止改约`);
    }

    if (dotAndNetList.length) {
        showMessage(`订单号${taskNosStr(dotAndNetList)}，共${dotAndNetList.length}单已自动剔除, 宅配、网点配送订单禁止改约`);
    }

    if (cainiaoList.length) {
        showMessage(`订单号${taskNosStr(cainiaoList)}，共${cainiaoList.length}单已自动剔除, 菜鸟调拨出库、纯运输订单禁止改约`);
    }

    if (cspReverseList.length) {
        showMessage(`订单号${taskNosStr(cspReverseList)}，共${cspReverseList.length}单已自动剔除, 退货入库单禁止改约`);
    }

    if (privatePersonList.length) {
        showMessage(`订单号${taskNosStr(privatePersonList)}，共${privatePersonList.length}单已自动剔除, 收货方为安得配送中心的订单禁止改约`);
    }

    return allowList;
}

export function imageMinimize (file, quality = DEFALUT_QUALITY, limitSize = DEFALUT_LIMITSIZE) {
    return new Promise(resolve => {
        if (file.size <= limitSize * ONE_KB * ONE_KB) { // 判断图片是否大于预设的大小，是就直接上传
            resolve(file);
        } else { // 反之压缩图片
            const reader = new FileReader();
            // 将图片转成 base64 格式
            reader.readAsDataURL(file);
            // console.log(reader);
            // 读取成功后的回调
            reader.onloadend = function () {
                const result = this.result;
                const img = new Image();
                img.src = result;
                img.onload = function () {
                    const canvas = document.createElement('canvas');
                    const ctx = canvas.getContext('2d');
                    let targetWidth = img.width;
                    let targetHeight = img.height;
                    if (img.width > CTX_WIDTH || img.height > CTX_HEIGHT) {
                        if (img.width / img.height > CTX_WIDTH / CTX_HEIGHT) {
                            // 更宽，按照宽度限定尺寸
                            targetWidth = CTX_WIDTH;
                            targetHeight = Math.round(CTX_WIDTH * (img.height / img.width));
                        } else {
                            targetHeight = CTX_HEIGHT;
                            targetWidth = Math.round(CTX_HEIGHT * (img.width / img.height));
                        }
                    }
                    canvas.width = targetWidth;
                    canvas.height = targetHeight;
                    ctx.drawImage(img, 0, 0, targetWidth, targetHeight);
                    const ndata = canvas.toDataURL('image/jpeg', quality);
                    resolve(dataURItoBlob(ndata, file.type));
                };
            };
        }
    });
};

